import { ERegExpTypes } from 'constants/RegExpTypes';
import { useTranslations } from 'hooks/useTranslations';
import * as yup from 'yup';

const useEditAccountDataFormSchema = () => {
  const { t } = useTranslations();
  const schema = yup.object({
    email: yup
      .string()
      .email(t('page.myProfile.accountData.validation.email.format'))
      .max(254, 'This field should have max 255 characters.')
      .required(t('page.myProfile.accountData.validation.email.required')),
    retypeEmail: yup
      .string()
      .required(t('page.myProfile.accountData.validation.email.required'))
      .oneOf([yup.ref('email')], t('page.myProfile.accountData.validation.email.notMatch')),
    prefixPhoneNumberUniqueId: yup
      .string()
      .required(t('page.myProfile.accountData.validation.prefix.required')),
    phoneNumber: yup
      .string()
      .required(t('page.myProfile.accountData.validation.phone.required'))
      .matches(
        new RegExp(ERegExpTypes.onlyDigits),
        t('page.myProfile.accountData.validation.phone.valueIsNotCorrect'),
      )
      .max(
        15,
        t('page.myProfile.accountData.validation.phone.maxNumberCharacters').replace(
          '{0}',
          '15',
        ),
      )
      .min(
        5,
        t('page.myProfile.accountData.validation.phone.minNumberCharacters').replace(
          '{0}',
          '5',
        ),
      )
      .trim(),
  });

  const schemaCode = yup.object({
    smsCode: yup
      .string()
      .required(t('page.myProfile.accountData.validation.smsCode.required')),
  });

  return { schema, schemaCode };
};

export default useEditAccountDataFormSchema;
